import { useEffect, useState } from 'react';

// returns true if browser tab is active/in-focus
export const checkIfBrowserTabIsVisible = () => document.visibilityState === 'visible';

// unused right now, but will be useful if we need to trigger a re-render
function useBrowserTabVisibility() {
  const [visible, setVisible] = useState(true);

  const onVisibilityChange = () => {
    setVisible(checkIfBrowserTabIsVisible());
  };

  useEffect(() => {
    document.addEventListener('visibilitychange', onVisibilityChange);
    return () => document.removeEventListener('visibilitychange', onVisibilityChange);
  }, []);

  return visible;
}

export default useBrowserTabVisibility;
